import { isCircuitFile, type CircuitFile } from './storage';

/**
 * 회로를 URL 해시에 담아 공유한다.
 *   #c=<deflate-raw 압축 + base64url>   (CompressionStream 지원 브라우저)
 *   #j=<JSON base64url>                  (지원 안 하면)
 * 해시는 서버로 전송되지 않으니 Netlify 같은 정적 호스팅에서도 그대로 동작한다.
 */

function toBase64Url(bytes: Uint8Array): string {
  let bin = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) bin += String.fromCharCode(...bytes.subarray(i, i + chunk));
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fromBase64Url(s: string): Uint8Array {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4);
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

async function pipe(bytes: Uint8Array, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> {
  const res = new Response(new Blob([bytes as BlobPart]).stream().pipeThrough(stream));
  return new Uint8Array(await res.arrayBuffer());
}

export async function encodeShare(file: CircuitFile): Promise<string> {
  const slim: CircuitFile = { ...file, savedAt: '' };
  const json = new TextEncoder().encode(JSON.stringify(slim));
  if (typeof CompressionStream !== 'undefined') {
    const packed = await pipe(json, new CompressionStream('deflate-raw'));
    return `c=${toBase64Url(packed)}`;
  }
  return `j=${toBase64Url(json)}`;
}

export async function decodeShare(hash: string): Promise<CircuitFile | null> {
  const h = hash.replace(/^#/, '');
  try {
    let json: Uint8Array;
    if (h.startsWith('c=')) {
      json = await pipe(fromBase64Url(h.slice(2)), new DecompressionStream('deflate-raw'));
    } else if (h.startsWith('j=')) {
      json = fromBase64Url(h.slice(2));
    } else return null;
    const data = JSON.parse(new TextDecoder().decode(json));
    return isCircuitFile(data) ? data : null;
  } catch (e) {
    console.warn('공유 링크를 읽을 수 없어요', e);
    return null;
  }
}

export async function makeShareUrl(file: CircuitFile): Promise<string> {
  const payload = await encodeShare(file);
  return `${location.origin}${location.pathname}${location.search}#${payload}`;
}
